<template>
  <div class="help padding_top">
    <p><strong>【步骤】：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>
      ，即可进入【医生工作室】，在顶部菜单栏中点击<span class="orange">【文章管理】</span>，页面展示【文章列表】
    </p>
    <img src="../../../assets/doctorImg/article_a.png" alt="">
    <p>
      【子菜单】点击可切换文章类型<br/>
      【每日研究】最新心理研究文章<br/>
      【新闻资讯】前沿心理科学资讯<br/>
      【公益科普】浅显易懂心理知识
    </p>
    <p class="mt_20">
      【按钮功能介绍】<br/>
      【取消发布】将文章取消发布, 回到草稿状态<br/>
      【删除】删除后不可恢复,请谨慎操作<br/>
      【编辑】进入编辑页，重新编辑文章内容<br/>
    </p>
    <p class="mt_20">
      【文章状态】<br/>
      【审核通过】处于发布状态，在网站对应模块展示，无法编辑内容<br/>
      【审核中】处于审核状态， 待后台审核后正式发布，无法编辑内容<br/>
      【审核拒绝】被后台审核拒绝，此时文章可重新编辑或删除<br/>
      【违规封禁】正式发布后，由于不符合管理规范，被后台封禁，此时无法修改、删除<br/>
      【草稿】处于草稿状态，可自由编辑修改、删除等
    </p>
    <p class="mt_20"><strong>【新增文章】：</strong></p>
    <p>① 在顶部菜单栏中点击<span class="orange">【文章管理】</span>，点击右上角【新增文章】按钮，进入【新增文章页面】</p>
    <img src="../../../assets/doctorImg/article_b.png" alt="" height="248">
    <p>② 在【新增文章页面】，选择文章类型，按照提示填写文章内容，点击<span class="orange">【提交】</span>按钮，完成文章编辑，文章状态为待审核，等待后台管理员审核后，文章正式发布，在个人主页中优先展示医生发布的文章<br/>
      【登录可见】<br/>
      选择【是】时，文章正式发布后，用户需登录后才能查看完整文章<br/>
      选择【否】时，文章正式发布后，用户不需登录也可查看完整文章
    </p>
    <img src="../../../assets/doctorImg/article_c.png" alt="">
  </div>

</template>

<script>
export default {
  name: "articleDoctor",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
